import { render, staticRenderFns } from "./TheVdpModal.vue?vue&type=template&id=5d22e8e2"
import script from "./TheVdpModal.vue?vue&type=script&lang=js"
export * from "./TheVdpModal.vue?vue&type=script&lang=js"
import style0 from "./TheVdpModal.vue?vue&type=style&index=0&id=5d22e8e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports